import { render, staticRenderFns } from "./learners.vue?vue&type=template&id=9acc48d0"
import script from "./learners.vue?vue&type=script&lang=js"
export * from "./learners.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports